import { useState } from 'react';
import { Icon } from '@/components/Icon';
import { track } from '@/lib/analytics';
import { happRedirectURL } from '@/lib/happ';
import { haptic, notify, openExternalLink } from '@/lib/telegram';
import { ImportantNote, Italic, StepHead, StepHero } from './parts';

interface SetupSubProps {
  subscriptionUrl: string;
  onNext: () => void;
  onBack: () => void;
}

export function SetupSub({ subscriptionUrl, onNext, onBack }: SetupSubProps) {
  const [done, setDone] = useState(false);
  const redirectUrl = happRedirectURL(subscriptionUrl);
  const hasUrl = Boolean(redirectUrl);

  // Tap opens the HTTPS redirect page in Safari via WebApp.openLink.
  // Safari fires the happ:// deeplink from inside the redirect page,
  // bypassing Telegram iOS's custom-scheme whitelist. We flip to "done"
  // optimistically — the OS handoff isn't observable from JS.
  const handleTap = () => {
    if (!redirectUrl) return;
    haptic('medium');
    setDone(true);
    notify('success');
    track('miniapp_happ_link_opened', { surface: 'ios_main', platform: 'ios' });
    openExternalLink(redirectUrl);
  };

  return (
    <div
      style={{
        padding: '12px 18px 130px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
      }}
    >
      <StepHead
        n={2}
        eyebrow="подписка"
        title={
          <>
            добавь <Italic>конфиг.</Italic>
          </>
        }
        sub="нажми кнопку — happ откроется и предложит добавить подписку"
      />

      <StepHero
        glyph={done ? '✓' : '+'}
        label={done ? 'подписка отправлена в happ' : 'твоя подписка'}
        accent={done}
      />

      <ImportantNote icon="key">
        <span style={{ color: 'var(--ink)' }}>один ключ — все твои устройства.</span> подписка
        хранится в happ. удалишь — нажми «добавить подписку» снова
      </ImportantNote>

      {!hasUrl && (
        <ImportantNote icon="info">
          <span style={{ color: 'var(--warn)' }}>сначала оформи подписку.</span> без неё нечего
          добавлять в happ. вернись на главную и начни с триала
        </ImportantNote>
      )}

      <div style={{ flex: 1 }} />

      {!done ? (
        <button
          onClick={handleTap}
          disabled={!hasUrl}
          className="btn btn-moss"
          style={{
            width: '100%',
            height: 54,
            fontSize: 14.5,
            marginBottom: 10,
            opacity: hasUrl ? 1 : 0.45,
            cursor: hasUrl ? 'pointer' : 'not-allowed',
          }}
        >
          <Icon name="plus" size={15} stroke="#fff" sw={2} />
          добавить подписку в happ
        </button>
      ) : (
        <>
          <button
            onClick={() => {
              haptic('medium');
              onNext();
            }}
            className="btn btn-moss"
            style={{ width: '100%', height: 54, fontSize: 14.5, marginBottom: 8 }}
          >
            следующий шаг
            <Icon name="arrow" size={14} stroke="#fff" sw={2} />
          </button>
          <button
            onClick={handleTap}
            className="btn btn-ghost"
            style={{ width: '100%', height: 44, fontSize: 12.5, marginBottom: 6 }}
          >
            повторить
          </button>
        </>
      )}
      <button
        onClick={() => {
          haptic('light');
          onBack();
        }}
        className="btn btn-paper"
        style={{ width: '100%', height: 50, fontSize: 13.5 }}
      >
        назад
      </button>
    </div>
  );
}
